import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import BingoPage from "./pages/BingoPage"
import SorteioAleatorioPage from "./pages/SorteioAleatorioPage"
import useBingoStore from "./store";

function App() {
  const { bingoName, isConfigured } = useBingoStore();
  
  const displayTitle = isConfigured && bingoName ? bingoName : "Bingo Online Gratuito";

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="min-h-screen bg-gray-100">
          <nav className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 flex justify-between items-center shadow-lg">
            <h1 className="text-2xl font-bold truncate max-w-[60%]">{displayTitle}</h1>
            <div className="space-x-4 flex items-center">
              <Link to="/" className="hover:underline font-medium">
                Bingo
              </Link>
              <Link to="/sorteio-aleatorio" className="hover:underline font-medium">
                Sorteio Aleatório
              </Link>
            </div>
          </nav>

          <div className="p-4">
            <Routes>
              <Route path="/" element={<BingoPage />} />
              <Route path="/sorteio-aleatorio" element={<SorteioAleatorioPage />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
